import labels_tr from "../utils/labels_tr.json";
import labels_uk from "../utils/labels_uk.json";
import labels_global from "../utils/labels_global.json";
import labels_no from "../utils/labels_no.json";
import labels_pl from "../utils/labels_pl.json";
import labels_jp from "../utils/labels_jp.json";

export const DEFAULT_COUNTRY_KEY = "global";
export const DEFAULT_MODEL_CONTROL_NAME = "id_card";

//when a new country will be added,
//1) Country binary code to “COUNTRY_MODEL_MAP”,
//2) the number “MODEL_SHARD_CONFIG” according to the number inside the tfjs model,
//3) After adding label_countryBinaryCode for the country into the utils file, it is added to “LABEL_FILES” as appropriate for that country.

export const COUNTRY_MODEL_MAP = {

};

export const COUNTRIES_WITH_CUSTOM_MODEL = Object.keys(COUNTRY_MODEL_MAP);

export const MODEL_SHARD_CONFIG = {
    // tr: 3,
    // uk: 3,
    // no: 5,
    // pl: 5,
    // jp: 5,
    [DEFAULT_COUNTRY_KEY]: 2
};

export const LABEL_FILES = {
    tr: labels_tr,
    uk: labels_uk,
    pl: labels_pl,
    no: labels_no,
    jp: labels_jp,
    [DEFAULT_COUNTRY_KEY]: labels_global,
};